import { Controller, useFormContext } from "react-hook-form";
import { Select, SelectOption } from "rizzui";

type GoogleAdsAccountPageProps = {
  name: string;
  options: SelectOption[];
};

export default function GoogleAdsAccountPage({
  name,
  options,
}: GoogleAdsAccountPageProps) {
  const { control } = useFormContext();

  return (
    <div className="grid w-full grid-cols-1 gap-6">
      <div className="grid w-full grid-cols-1 gap-2">
        <h6 className="text-foreground md:text-base">Google Ads Account</h6>
        <p className="text-sm text-gray-500">
          Select which Google Ads Account this user will use for campaigns.
        </p>
      </div>

      <Controller
        control={control}
        name={`${name}.googleAdsAccountId`}
        render={({ field, fieldState }) => (
          <Select
            label="Google Ads Account"
            placeholder="Select Google Ads account"
            options={options}
            value={field.value}
            onChange={field.onChange}
            getOptionValue={(option: SelectOption) => option.value}
            displayValue={(selected: string) =>
              options.find((option) => option.value === selected)?.label || ""
            }
            error={fieldState.error?.message}
          />
        )}
      />
    </div>
  );
}
